import { render, staticRenderFns } from "./pickingrecord.vue?vue&type=template&id=54b4aabb&scoped=true&"
import script from "./pickingrecord.vue?vue&type=script&lang=js&"
export * from "./pickingrecord.vue?vue&type=script&lang=js&"
import style0 from "./pickingrecord.vue?vue&type=style&index=0&id=54b4aabb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4aabb",
  null
  
)

export default component.exports